import { DestroyRef, Directive, DOCUMENT, ElementRef, inject } from '@angular/core';
import { InfiniteScrollDirective } from './infinite-scroll';

@Directive({
  selector: '[appInViewport]',
})
export class InViewportDirective {
  private document = inject(DOCUMENT);
  private elementRef = inject(ElementRef);
  private destroyRef = inject(DestroyRef);
  private infiniteScroll = inject(InfiniteScrollDirective, { optional: true });

  constructor() {
    if (this.infiniteScroll) {
      this.infiniteScroll.register(this);
      this.destroyRef.onDestroy(() => this.infiniteScroll!.unregister(this));
    }
  }

  isInViewPort() {
    const rect = this.elementRef.nativeElement.getBoundingClientRect();
    return rect.top < this.document.documentElement.clientHeight && rect.bottom > 0;
  }
}
